/** Lines to paste into Cursor Cloud → Secrets (values only; user adds in dashboard). */
export function formatNetlifyEnvExport(apiToken: string, siteUrl: string): string {
  const token = apiToken.trim();
  const site = siteUrl.trim();
  const lines = [
    '# Paste into Cursor Cloud → Secrets (Runtime secret for token recommended)',
    token ? `NETLIFY_AUTH_TOKEN=${token}` : 'NETLIFY_AUTH_TOKEN=',
    site ? `NETLIFY_SITE_URL=${site}` : 'NETLIFY_SITE_URL=',
  ];
  return lines.join('\n');
}
